import IconButton from "@components/library/IconButton";
import { IconButtonWithShortcut } from "@components/library/IconButtonWithShortcut";
import KeyboardShortcut from "@components/library/KeyboardShortcut";
import Tooltip from "@components/library/Tooltip";
import { ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon } from "@heroicons/react/outline";

interface Props {
  handlePrev: undefined | (() => void);
  handleNext: undefined | (() => void);
  className?: string;
  shortcutPrev?: string[];
  shortcutNext?: string[];
  shortcutPrevTooltip?: string;
  shortcutNextTooltip?: string;
}

export const UpDownPaginationButtons = ({
  handlePrev,
  handleNext,
  shortcutPrev = ["k", "arrowup"],
  shortcutNext = ["j", "arrowdown"],
  shortcutPrevTooltip = "K",
  shortcutNextTooltip = "J",
  className,
}: Props) => {
  return (
    <div className={className ?? "flex h-24 items-center overflow-hidden rounded-ms border border-stroke-base-3 pb-0"}>
      <Tooltip
        side="bottom"
        content={
          <div className="flex items-center gap-6">
            Previous <KeyboardShortcut>{shortcutPrevTooltip}</KeyboardShortcut>
          </div>
        }
      >
        <IconButtonWithShortcut
          shortcut={shortcutPrev}
          className="rounded-sm rounded-r-none"
          Icon={ChevronUpIcon}
          size={24}
          disabled={!handlePrev}
          onClick={handlePrev}
        />
      </Tooltip>
      <Tooltip
        side="bottom"
        content={
          <div className="flex items-center gap-6">
            Next <KeyboardShortcut>{shortcutNextTooltip}</KeyboardShortcut>
          </div>
        }
      >
        <IconButtonWithShortcut
          shortcut={shortcutNext}
          className="rounded-sm rounded-l-none"
          Icon={ChevronDownIcon}
          size={24}
          disabled={!handleNext}
          onClick={handleNext}
        />
      </Tooltip>
    </div>
  );
};

export const LeftRightPaginationButtons = ({ handlePrev, handleNext }: Props) => {
  return (
    <div className="rounded-ms border border-stroke-base-3 p-1 pb-0">
      <IconButton
        className="rounded-sm rounded-r-none"
        Icon={ChevronLeftIcon}
        size={24}
        disabled={!handlePrev}
        onClick={handlePrev}
      />
      <IconButton
        className="rounded-sm rounded-l-none"
        Icon={ChevronRightIcon}
        size={24}
        disabled={!handleNext}
        onClick={handleNext}
      />
    </div>
  );
};
